<template>
  <div class="p-12 a10-footer-bg text-gray-100">
    <div class="flex flex-wrap">
      <div class="w-full md:w-1/2 text-center md:text-left">
        <p class="text-base mb-2 text-sm">
          Dependent de Artă - Cel mai mare magazin de artă din România
          <br>
        </p>
        <p class="mb-1 text-xs">
          Palatul Cesianu-Racoviţă, Str. C.A. Rosetti 5, 010281 București
        </p>
        <p class="mb-1 text-xs">
          <a href="mailto:office@artmark.ro"
             class="text-gray-100 transition ease-in-out duration-150">office@dependentdearta.ro</a>
        </p>
        <p class="text-gray-100 text-xs">
          <a class="transition ease-in-out duration-150" href="tel:+40212103016"> +40 21
            210 30 16</a>
          /
          <a class="transition ease-in-out duration-150" href="tel:+4021 210 30 15">+40 21
            210 30 15</a>
        </p>
      </div>
      <div class="w-full md:w-1/2 text-center md:text-right mt-4 md:mt-0">
        <div class="text-base mb-1 text-sm">&copy;Dependent de artă 2019 - {{(new Date()).getFullYear()}}</div>

        <div class="">
          <!--                <span class="my-0 r-text-small  h3 text-uppercase  h5">{{ $t('footer.menu_titles.social') }}</span>-->
          <div class="flex mt-2 sm:justify-end justify-center">
            <a class="social mx-2 flex-2" href="https://www.facebook.com/dependentdearta" target="_blank"><img
                src="/assets/img/footer/facebook.svg"
                alt="Artmark Facebook" class="social_logo"/></a>
            <a class="social mx-2 flex-2" href="https://www.instagram.com/dependentdearta.ro"
               target="_blank"><img
                src="/assets/img/footer/insta.svg" class="social_logo"
                alt="Artmark Instagram"/></a>
            <a class="social yt mx-2 flex-2" href="https://www.linkedin.com/company/dependent-de-arta"
               target="_blank"><img src="/assets/img/footer/linkedin.svg"
                                    alt="Artmark LinkedIn" class="social_logo"/></a>
          </div>
        </div>
        <!--                <div class="flex justify-center md:justify-end">-->
        <!--                    <a class="fill-current text-gray-300 opacity-75 hover:opacity-100 mr-2 transition ease-in-out duration-150"-->
        <!--                       href="https://www.instagram.com/dependentdearta.ro/" target="_blank">-->
        <!--                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"-->
        <!--                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
        <!--                             viewBox="0 0 512 512" style="enable-background:new 0 0 512 512; max-height: 25px"-->
        <!--                             xml:space="preserve">-->

        <!--		<path d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160-->
        <!--			C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48-->
        <!--			h192c61.76,0,112,50.24,112,112V352z"/>-->

        <!--                            <path d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336-->
        <!--			c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"/>-->

        <!--                            <circle cx="393.6" cy="118.4" r="17.056"/>-->


        <!--</svg>-->

        <!--                    </a>-->
        <!--                    <a class="fill-current text-gray-300 opacity-75 hover:opacity-100 transition ease-in-out duration-150"-->
        <!--                       href="https://www.facebook.com/dependentdearta" target="_blank">-->
        <!--                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"-->
        <!--                             x="0px"-->
        <!--                             y="0px" width="24px" height="24px" viewBox="0 0 90 90"-->
        <!--                             style="enable-background:new 0 0 90 90;"-->
        <!--                             xml:space="preserve">-->
        <!--              <path-->
        <!--                      d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"-->
        <!--                      data-original="#000000" class="active-path" data-old_color="#ffffff" fill="#ffffff"/></svg>-->
        <!--                    </a>-->
        <!--                </div>-->
      </div>
    </div>

    <hr class="mt-4 border-t border-gray-700 opacity-50"/>
    <!--      AICI VINE FOOTER MENU-->
    <FooterMenu />
    <hr class="mt-4 border-t border-gray-700 opacity-50"/>

    <div class="text-gray-500 text-sm text-center pt-4">Powered by
      <a target="_blank" href="http://artgames.ro">ART GAMES</a>
    </div>
  </div>
</template>

<style scoped>
.swiper-slide {
  background-color: rgba(0, 0, 0, 0);
  visibility: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: auto !important;
  vertical-align: middle;
  width: 128px;
}

.social img {
  width: 23px;
  height: 23px;
}
</style>

<script>
import 'swiper/dist/css/swiper.css';
import  FooterMenu from '@/Shared/FooterMenu';
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper';

export default {
  components: {
    swiper,
    swiperSlide,
    FooterMenu
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        speed: 200,
        autoplay: {
          delay: 4000,
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          }
        }
      }
    }
  }
}
</script>
